import { ProjectStatusTranslator } from 'src/translators/ProjectStatusTranslator'
import { useGetProjectStatusesQuery } from 'src/types/generated'

/** 住戸に紐づくセレクト設問一覧取得 */
export const useGetProjectStatuses = () => {
  const { loading, data, error, refetch } = useGetProjectStatusesQuery()

  return {
    loading,
    projectStatuses: data ? ProjectStatusTranslator.toEntities(data.projectStatuses) : [],
    error,
    refetch,
  }
}
